import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const isTest = false
const store = new Vuex.Store({
  state: {
    BASE_PATH: '/c',
    isTest: isTest,
    IMG_HOST: isTest ? 'http://static2.test.ximalaya.com/lib/new_a_pc/last/dist/src/assets/' : 'http://s1.xmcdn.com/lib/new_a_pc/last/dist/src/assets/',
    // IMG_HOST: 'http://192.168.136.61:8080/new_a_pc/src/assets/',
    XMLY_INDEX_URL: isTest ? 'http://test.ximalaya.com/' : 'http://www.ximalaya.com/',
    ANCHOR_AUTH_URL: isTest ? 'http://test.ximalaya.com/verify' : 'http://www.ximalaya.com/verify',
    ANCHOR_COLLEGE_URL: 'http://blog.ximalaya.com/category/college/',
    XMLY_MOBILE_URL: isTest ? 'http://test.ximalaya.com/download' : 'http://www.ximalaya.com/download',
    LOGIN_URL: isTest ? 'http://test.ximalaya.com/passport/login' : 'http://www.ximalaya.com/passport/login',
    REGISTER_URL: isTest ? 'http://test.ximalaya.com/passport/register' : 'http://www.ximalaya.com/passport/register',
    HOST: isTest ? 'http://a2.test.ximalaya.com/c' : 'http://a.ximalaya.com/c',
    A_PC_HOST: isTest ? 'http://a2.test.ximalaya.com' : 'http://a.ximalaya.com',
    UPLOAD_IMG_HOST: isTest ? 'http://fdfs.test.ximalaya.com/' : 'http://fdfs.xmcdn.com/',
    DEFAULT_PORTRAIT_200: 'http://s1.xmcdn.com/css/img/common/default/user200.jpg',
    DEFAULT_PORTRAIT_100: 'http://s1.xmcdn.com/css/img/common/default/user100.jpg',
    DEFAULT_BOOK_COVER: 'http://s1.xmcdn.com/lib/new_a_pc/last/dist/src/assets/bookCoverDefault.png',
    UNHANDLE_EVENT: 0,
    DUB_HOST: 'http://xpy.ximalaya.com',
    // DUB_HOST: 'http://xpy.ximalaya.com/view/create/book/import',
    user: {
      name: '',
      login: false,
      logoPic: '',
      isOperator: false,    //是否为运营账号
      isDubAnchor: false,   // 是否为喜配音主播
      author: {
        authorProgressStatus: 0, // 0:未提交审核; 1:审核中; 5:审核失败; 9:已认证
        authorProgressLabel: '',
        type: null,   // 1.作家; 2.出版社
        typeLabel: '',
        rejectionReason: ''
      },
      anchor: {
        level: -1,  // 主播等级，0及以上为认证主播
        type: -1   //主播类型 0 未认证   1 个人  2组织
      }
    },
    publishFrequency: [
      '每天1集','每天2集','每天3集', '两天1集', '每周1集','不限'
    ],
    publishMethods: [{
    //   label: '无需发布',
    //   value: 1
    // }, {
      label: '创建主播免费专辑',
      value: 2
    }, {
      label: '创建主播付费专辑',
      value: 3
    }, {
      label: '创建版权方免费专辑',
      value: 6
    }, {
      label: '创建版权方付费专辑',
      value: 7
    }],
    playMode: [{
      label: '不限',
      value: 1
    }, {
      label: '单人',
      value: 2
    }, {
      label: '男女双人',
      value: 3
    }, {
      label: '多人小说剧',
      value: 4
    }, {
      label: '多人广播剧',
      value: 5
    }],
    additionLimits: [{
      label: '3天',
      value: 3
    }, {
      label: '7天',
      value: 7
    }, {
      label: '10天',
      value: 10
    }, {
      label: '15天',
      value: 15
    }]
  },
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js